module.exports = __webpack_public_path__ + "media/es_es_s1_Celesta.c5fd4ad3.oga";